<template>
  <qrcode-vue :value="value" :size="size" class="ma-0"></qrcode-vue>
</template>
<script>
import QrcodeVue from "qrcode.vue";

export default {
  props: ["value"],
  data() {
    return {
      size: 250
    };
  },
  components: {
    QrcodeVue
  }
};
</script>
